import { withInstall } from '@ll-plus/utils'

import TimePicker from './src/time-picker.vue'

export const LlTimePicker = withInstall(TimePicker)
export default LlTimePicker
export * from './src/time-picker'

declare module 'vue' {
  export interface GlobalComponents {
    LlTimePicker: typeof TimePicker
  }
}
